export default "__VITE_ASSET__CYtBUNjv__"